module.exports = __webpack_public_path__ + "img/9000.2e4d821c.jpg";